import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import SubscriptionsView from '@/views/portal/SubscriptionsView.vue'
import UsersView from '@/views/portal/UsersView.vue'
import CouponsView from '@/views/portal/CouponsView.vue'
import InvoicesView from '@/views/portal/InvoicesView.vue'
import PortalHomeView from '@/views/portal/PortalHomeView.vue'
import CompanyProfileView from '@/views/portal/CompanyProfileView.vue'
import MyProfileView from '@/views/portal/MyProfileView.vue'
import LandingHomeView from '@/views/LandingHomeView.vue'
import AppPortal from '@/views/AppPortal.vue'
import ApiEventsView from '@/views/portal/ApiEventsView.vue'
import ApiKeysView from '@/views/portal/ApiKeysView.vue'
import AccessCodesView from '@/views/portal/AccessCodesView.vue'
import PaymentMethodsView from '@/views/portal/PaymentMethodsView.vue'
import EquipmentView from '@/views/portal/EquipmentView.vue'

Vue.use(VueRouter)

export enum RoutePaths {
  LANDING_HOME = '/',
  PORTAL_HOME = '/portal',
  COUPONS = '/portal/coupons',
  INVOICES = '/portal/invoices',
  PAYMENT_METHODS = '/portal/payment_methods',
  SUBSCRIPTIONS = '/portal/subscriptions',
  USERS = '/portal/users',
  EQUIPMENT = '/portal/equipment',
  ACCESS_CODES = '/portal/access_codes',
  API_EVENTS = '/portal/api_events',
  API_KEYS = '/portal/api_keys',
  COMPANY_PROFILE = '/portal/company_profile',
  MY_PROFILE = '/portal/my_profile',
  DOCS_USER_MANUAL = '/docs/user-manual.pdf',
}

const routes: Array<RouteConfig> = [
  {
    path: RoutePaths.LANDING_HOME,
    name: 'Landing Home',
    component: LandingHomeView
  },
  {
    path: '/portal',
    name: 'Portal',
    component: AppPortal,
    children: [
      {
        path: '',
        name: 'Portal Home',
        component: PortalHomeView
      },
      {
        path: 'coupons',
        name: 'Coupons',
        component: CouponsView
      },
      {
        path: 'invoices',
        name: 'Invoices',
        component: InvoicesView
      },
      {
        path: 'payment_methods',
        name: 'Payment Methods',
        component: PaymentMethodsView
      },
      {
        path: 'subscriptions',
        name: 'Subscriptions',
        component: SubscriptionsView
      },
      {
        path: 'users',
        name: 'Users',
        component: UsersView
      },
      {
        path: 'equipment',
        name: 'Equipment',
        component: EquipmentView
      },
      {
        path: 'access_codes',
        name: 'Access Codes',
        component: AccessCodesView
      },
      {
        path: 'api_events',
        name: 'API Events',
        component: ApiEventsView
      },
      {
        path: 'api_keys',
        name: 'API Keys',
        component: ApiKeysView
      },
      {
        path: 'company_profile',
        name: 'CompanyProfile',
        component: CompanyProfileView
      },
      {
        path: 'my_profile',
        name: 'MyProfile',
        component: MyProfileView
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
